import { MoeConfidence } from 'common/types/account';
import { atom } from 'recoil';

export const MoeConfidenceLevelsAtom = atom<MoeConfidence | null>({
  key: 'moeConfidenceLevels',
  default: null,
});
